import { render, staticRenderFns } from "./AttachmentsAccordion.vue?vue&type=template&id=80c65e40&scoped=true&"
import script from "./AttachmentsAccordion.vue?vue&type=script&lang=js&"
export * from "./AttachmentsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsAccordion.vue?vue&type=style&index=0&id=80c65e40&scoped=true&lang=less&"
import style1 from "./less/attachments.less?vue&type=style&index=1&module=%24&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style1.locals || style1)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./less/attachments.less?vue&type=style&index=1&module=%24&lang=css&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("./less/attachments.less?vue&type=style&index=1&module=%24&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("80c65e40")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "80c65e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80c65e40')) {
      api.createRecord('80c65e40', component.options)
    } else {
      api.reload('80c65e40', component.options)
    }
    module.hot.accept("./AttachmentsAccordion.vue?vue&type=template&id=80c65e40&scoped=true&", function () {
      api.rerender('80c65e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/attachments/AttachmentsAccordion.vue"
export default component.exports